import { useCallback, useMemo } from "react";

import {
  GuideTourHost as PackageGuideTourHost,
  GUIDE_TOUR_TARGET_SEARCH_INTERVAL_MS,
  GUIDE_TOUR_TARGET_SEARCH_TIMEOUT_MS,
} from "../../packages/guide-tour/src";
import { useAuthStore } from "../stores/authStore";

import { GUIDE_TOUR_CONFIG, getGuideTourStepsForModule } from "./guideTourConfig";
import { getGuideTourPersistence } from "./guideTourStorage";
import type { GuideTourModule } from "./types";

interface GuideTourHostProps {
  targetSearchIntervalMs?: number;
  targetSearchTimeoutMs?: number;
}

function getGuideTourModuleLabel(module: GuideTourModule): string {
  return GUIDE_TOUR_CONFIG[module].label;
}

export function GuideTourHost({
  targetSearchIntervalMs = GUIDE_TOUR_TARGET_SEARCH_INTERVAL_MS,
  targetSearchTimeoutMs = GUIDE_TOUR_TARGET_SEARCH_TIMEOUT_MS,
}: GuideTourHostProps) {
  const user = useAuthStore((state) => state.user);
  const persistence = useMemo(() => getGuideTourPersistence(user), [user]);
  const resolveSteps = useCallback(
    (module: GuideTourModule) => getGuideTourStepsForModule(user, module),
    [user],
  );

  return (
    <PackageGuideTourHost
      getModuleLabel={getGuideTourModuleLabel}
      persistence={persistence}
      resolveSteps={resolveSteps}
      targetSearchIntervalMs={targetSearchIntervalMs}
      targetSearchTimeoutMs={targetSearchTimeoutMs}
    />
  );
}
